import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getBusinessConfiguration = async (
  businessId,
  activeEmployerInfo = {}
) => {
  const apiPath = `business/${businessId}/get-business-configuration`;
  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
    isLocalApiRequest: true
  });

  try {
    const response = await axios(signedRequest);
    return response.data;
  } catch (error) {
    if (error?.response?.status === 404) {
      return null;
    }

    throw error;
  }
};
